import type { SupportedLanguage } from '../../../shared/i18n/types.no-deps'

const listeners: string[] = []

declare const window: Window &
    typeof globalThis & {
        zE: (app: string, func: string, args?: any) => void
    }

function zE(app: string, func: string, args?: any) {
    if (!window.zE) {
        // Fail silently if zendesk chat has not loaded for some reason
        // to avoid spamming logs on every page load
        return
    }
    window.zE(app, func, args)
}

export function showChat(hideOnClose: boolean = false) {
    zE('messenger', 'show')

    if (hideOnClose && !listeners.includes('close')) {
        zE('messenger:on', 'close', () => {
            hideChat()
        })
        listeners.push('close')
    }
}

export function hideChat() {
    zE('messenger', 'hide')
}

export function openChat() {
    zE('messenger', 'open')
}

export function closeChat() {
    zE('messenger', 'close')
}

export function setLocale(locale: SupportedLanguage) {
    zE('messenger:set', 'locale', locale)
}

export function clearCookies() {
    zE('messenger:set', 'cookies', false)
}

export function initChat(locale?: SupportedLanguage) {
    closeChat()

    if (locale) {
        setLocale(locale)
    }

    if (listeners.includes('unreadMessages')) {
        return
    }

    zE('messenger:on', 'unreadMessages', (count: number) => {
        setTimeout(() => count && showChat(true), 0)
    })
    listeners.push('unreadMessages')
}

export const script = `<script id="ze-snippet" src="https://static.zdassets.com/ekr/snippet.js?key=4e99d8f3-4c73-452b-8a69-b7fb69fda840"> </script>`
export const scriptUrl = `https://static.zdassets.com/ekr/snippet.js?key=4e99d8f3-4c73-452b-8a69-b7fb69fda840`
export const zendeskCSP = {
    imageSrc: ['https://*.zdassets.com', 'https://zaptic.zendesk.com'],
    connectSrc: ['https://*.zdassets.com', 'https://zaptic.zendesk.com', 'https://*.smooch.io', 'wss://*.smooch.io'],
    scriptSrc: ['https://*.zdassets.com', 'https://*.smooch.io'],
}
